var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "10px",
    viewBox: "0 0 23 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_hand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2699\\uFE0F-Admin-(Desktop)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reporting",
    transform: "translate(-849, -714)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-9",
    transform: "translate(829, 689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_hand",
    transform: "translate(20, 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23461346,8.44634846 C5.30637042,8.61795997 5.21777938,8.81177986 5.03573954,8.88144576 L3.23785293,9.5556132 C3.05478977,9.62288136 2.84803628,9.5398322 2.77372158,9.36917998 L0.0248912534,2.93347381 C-0.0468657095,2.76186229 0.0417253273,2.5680424 0.223765172,2.49837651 L2.02165178,1.82420906 C2.06323463,1.80849102 2.10764669,1.80035391 2.15248261,1.80035391 C2.20129949,1.80047677 2.24957849,1.80991673 2.29437735,1.82809849 C2.38145356,1.86224165 2.45036484,1.92758897 2.48578313,2.00960511 L5.23461346,8.44634846 Z M22.5972702,3.76269977 C22.4393328,3.3581993 21.8504558,3.08853232 20.8876184,3.39683428 L16.6312784,4.51595224 C15.7309521,4.80506636 14.8414131,4.53721445 13.8995971,4.25380482 C13.1229205,3.98796729 12.3111756,3.82274099 11.4868333,3.76269977 C11.2303127,3.75214394 11.0228097,3.56329847 11.0039589,3.32324268 C10.9851081,3.08318689 11.1608752,2.86789213 11.4129816,2.82223618 L16.4603409,1.90147902 C17.3454543,1.74019743 17.862969,1.30691519 17.779713,0.797659476 C17.7030954,0.330928166 17.1086864,-0.0883521266 16.1201254,0.0161438277 C15.5849084,0.0726701752 15.1382027,0.121417667 14.7573273,0.162904895 C12.5379055,0.405086586 12.4977988,0.406123766 10.4648039,0.286329397 C10.1328864,0.266622964 9.74398967,0.243804989 9.28151792,0.218134767 C6.87511584,0.0845977531 5.63595707,1.13578038 4.54228881,2.06276062 C4.30330819,2.26552944 4.07207231,2.46000082 3.84194283,2.63139493 L5.75683037,7.11720141 C6.28580122,7.00229187 6.82360199,6.9266031 7.36524739,6.89083672 C8.41211703,6.85455768 9.46027019,6.86762535 10.5057404,6.92999029 C12.7608434,7.01685418 15.5674827,7.12472097 16.7477261,6.70051407 L21.7243271,4.97594188 C22.5339293,4.67982679 22.7444203,4.13945565 22.5972702,3.76269977 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHand);
export default __webpack_public_path__ + "static/media/icon_hand.06e2a4e2a33d6b11f54fbb549fdd9b99.svg";
export { ForwardRef as ReactComponent };